import { createContext } from 'react';

const ExpandNavbarContext = createContext(true);

export default ExpandNavbarContext;
